import React from 'react';

/* eslint-disable max-len,no-tabs,camelcase */
const Eyes_12 = ({ eyeColours, skinColours }) => {
  const colour0 = '#573D39';
  const colour1 = '#F15743';
  const colour2 = '#FFFEF0';
  const colour3 = '#F6E7D0';
  const colour4 = eyeColours.shadow;
  const colour5 = '#DF5656';
  const colour6 = skinColours.shadow;

  return (
    <>
      <g>
        <g>
          <path
            fill={colour0}
            d="M308.9,385.2c-0.7,3.5-1.9,12.9-6.2,15.3l14-1.4C317,388.3,309.5,381.7,308.9,385.2z"
          />
          <g>
            <path
              fill={colour0}
              d="M316.8,391.8c-2.8-0.8-7-4-7.1-5c-0.1-1,9.2-9.5,9.2-9.5L316.8,391.8z"
            />
            <path
              fill={colour1}
              opacity={0.5}
              d="M368.3,397.2c3-0.6,7.6-3.4,7.9-4.5c0.2-1-7.1-10.1-7.1-10.1L368.3,397.2z"
            />
            <path
              fill={colour0}
              d="M370.8,392.6c0.6-16.7-12.3-31.8-27.5-32.4c-15.2-0.6-28,12.5-28.6,29.2c-0.6,16.7,10.9,24.8,26.1,25.4
				C356,415.4,370.2,409.3,370.8,392.6z"
            />
            <path
              fill={colour2}
              d="M367.5,388.2c0.5-14.4-10.4-25.8-24.5-25.5c-14.1,0.3-25.9,12.2-26.4,26.6c-0.5,14.4,10.5,23.3,24.6,23
				C355.2,412,366.9,402.6,367.5,388.2z"
            />
            <path
              fill={colour3}
              d="M342.7,409c-14.1,0.3-25.1-9.4-24.5-23.7c0.1-2.3,0.5-4.6,1.1-6.7c-1.6,3.3-2.5,7-2.7,10.8
				c-0.5,14.4,10.5,24,24.5,23.7c11.9-0.2,22.2-7.6,25.4-18.6C362.2,403.1,353.1,408.7,342.7,409z"
            />
            <path
              fill={colour4}
              d="M355.1,391.1c0.3-7.1-5.5-13.1-13-13.4c-7.4-0.3-13.7,5.3-14,12.4c-0.3,7.1,5.5,13.1,13,13.4
				C348.6,403.7,354.9,398.2,355.1,391.1z"
            />
            <path
              fill={colour5}
              opacity={0.5}
              d="M376.2,392.7c-5.9-14.8-15.5-29.4-30.9-29.9c-13.9-0.5-32,10.3-35,23.8C328.7,380.8,360.7,381.2,376.2,392.7
				z"
            />
            <path
              fill={colour6}
              d="M311.2,383.8c3.1-7,37.8-22.1,63.7,5.8c0,0-4.1-29.8-30-30.8C314.7,357.7,311.2,383.8,311.2,383.8z"
            />
            <path
              fill={colour6}
              d="M310.9,380.7c-0.9,3.5-1.2,5.8-1.2,5.8c3.3-7.3,39.4-23.1,66.4,6.1c0,0-0.2-1.9-0.7-4.9
				C350.9,363.6,320.1,373.1,310.9,380.7z"
            />
            <path
              fill={colour2}
              d="M357.3,392.4c0.1-2.6-1.6-4.8-3.9-4.9c-2.2-0.1-4.1,2-4.2,4.6c-0.1,2.6,1.6,4.8,3.9,4.9
				C355.3,397,357.2,395,357.3,392.4z"
            />
            <path
              fill={colour2}
              d="M349.8,383.6c-0.6-1.4-1.8-2.3-2.7-2.1c-0.9,0.3-1.2,1.7-0.6,3.1c0.6,1.4,1.8,2.3,2.7,2
				C350.1,386.4,350.4,385,349.8,383.6z"
            />
          </g>
          <path
            fill={colour0}
            d="M376.8,393.7c-3.7,0.2-13.5-15.9-34.1-16.8c-20.6-1-30.3,7.2-32.7,10.8c0,0-2.9-2.6,0.8-7.7
			c3.7-5.1,18.1-11.6,33.3-7.8c18,4.5,30.4,19.8,37.7,19.1L376.8,393.7z"
          />
          <path
            fill={colour6}
            d="M316.3,402.7c0,0,4.3,15.9,25.8,15.4c16.5-0.4,26.7-12.4,29.1-21c0,0-15.8,10.2-32.8,9.1
			C321.2,405,316.3,402.7,316.3,402.7z"
          />
          <path
            fill={colour0}
            d="M378.8,392.7c-10.8,4.3-18.5,20.6-43.8,17.3c-25.3-3.3-19.6-8.6-39.3-6.2c0,0,12.1-7.4,20.6-5
			c8.6,2.4,22.2,8.3,34.9,5.3C361.4,401.7,371.1,392.8,378.8,392.7z"
          />
          <path
            fill={colour0}
            d="M298.3,374c0,0,7.8,7.6,14.1,7.3l-2.7,2.1C309.8,383.4,301.4,381.6,298.3,374z"
          />
          <path
            fill={colour0}
            d="M304,369.4c0,0,5.6,9.3,11.9,10.6l-3.1,1.4C312.7,381.4,305,377.5,304,369.4z"
          />
          <path
            fill={colour0}
            d="M309,366.5c0,0,4.9,9.7,11,11.5l-3.2,1.2C316.8,379.1,309.4,374.7,309,366.5z"
          />
          <path
            fill={colour0}
            d="M315.8,363.9c0,0,4.1,10.1,10,12.4l-3.3,0.9C322.5,377.2,315.5,372.1,315.8,363.9z"
          />
          <path
            fill={colour0}
            d="M323.6,361.8c0,0,0.5,8.8,5.2,10.6l-3.3,0.9C325.5,373.3,320.7,369.1,323.6,361.8z"
          />
        </g>
        <g>
          <path
            fill={colour0}
            d="M493.1,385.2c0.6,3.5,1.9,12.9,6.1,15.3l-13.8-1.4C485.2,388.3,492.5,381.7,493.1,385.2z"
          />
          <g>
            <path
              fill={colour0}
              d="M485.3,391.8c2.8-0.8,6.9-4,7-5c0.1-1-9.1-9.5-9.1-9.5L485.3,391.8z"
            />
            <path
              fill={colour1}
              opacity={0.5}
              d="M434.7,397.2c-2.9-0.6-7.5-3.4-7.7-4.5c-0.2-1,7-10.1,7-10.1L434.7,397.2z"
            />
            <path
              fill={colour0}
              d="M432.2,392.6c-0.6-16.7,12.1-31.8,27.1-32.4c14.9-0.6,27.6,12.5,28.2,29.2c0.6,16.7-10.7,24.8-25.6,25.4
				C446.8,415.4,432.8,409.3,432.2,392.6z"
            />
            <path
              fill={colour2}
              d="M435.5,388.2c-0.5-14.4,10.2-25.8,24.1-25.5c13.8,0.3,25.5,12.2,26,26.6c0.5,14.4-10.3,23.3-24.2,23
				C447.6,412,436,402.6,435.5,388.2z"
            />
            <path
              fill={colour3}
              d="M459.9,409c13.8,0.3,24.7-9.4,24.1-23.7c-0.1-2.3-0.5-4.6-1.1-6.7c1.6,3.3,2.5,7,2.6,10.8
				c0.5,14.4-10.3,24-24.1,23.7c-11.8-0.2-21.9-7.6-25-18.6C440.6,403.1,449.6,408.7,459.9,409z"
            />
            <path
              fill={colour4}
              d="M447.6,391.1c-0.3-7.1,5.5-13.1,12.8-13.4c7.3-0.3,13.5,5.3,13.8,12.4c0.3,7.1-5.5,13.1-12.8,13.4
				C454,403.7,447.9,398.2,447.6,391.1z"
            />
            <path
              fill={colour5}
              opacity={0.5}
              d="M426.9,392.7c5.9-14.8,15.2-29.4,30.4-29.9c13.7-0.5,31.5,10.3,34.4,23.8
				C473.6,380.8,442.1,381.2,426.9,392.7z"
            />
            <path
              fill={colour6}
              d="M490.9,383.8c-3.1-7-37.2-22.1-62.7,5.8c0,0,4-29.8,29.5-30.8C487.4,357.7,490.9,383.8,490.9,383.8z"
            />
            <path
              fill={colour6}
              d="M491.2,380.7c0.9,3.5,1.1,5.8,1.1,5.8c-3.2-7.3-38.8-23.1-65.4,6.1c0,0,0.2-1.9,0.7-4.9
				C451.8,363.6,482.1,373.1,491.2,380.7z"
            />
            <path
              fill={colour2}
              d="M468.8,394c-0.1-2.6,1.6-4.8,3.8-4.9c2.2-0.1,4.1,2,4.2,4.6c0.1,2.6-1.6,4.8-3.8,4.9
				C470.7,398.6,468.9,396.6,468.8,394z"
            />
            <path
              fill={colour2}
              d="M468.5,386.6c-1-1.2-1.2-2.7-0.5-3.3c0.7-0.6,2-0.2,3,1c1,1.2,1.2,2.7,0.5,3.3
				C470.8,388.2,469.5,387.8,468.5,386.6z"
            />
          </g>
          <path
            fill={colour0}
            d="M426.3,393.7c3.6,0.2,13.3-15.9,33.5-16.8c20.3-1,29.9,7.2,32.2,10.8c0,0,2.8-2.6-0.8-7.7
			c-3.6-5.1-17.8-11.6-32.8-7.8c-17.7,4.5-29.9,19.8-37.1,19.1L426.3,393.7z"
          />
          <path
            fill={colour6}
            d="M485.9,402.7c0,0-4.3,15.9-25.4,15.4c-16.3-0.4-26.3-12.4-28.7-21c0,0,15.5,10.2,32.3,9.1
			C481,405,485.9,402.7,485.9,402.7z"
          />
          <path
            fill={colour0}
            d="M424.3,392.7c10.6,4.3,18.2,20.6,43.1,17.3c24.9-3.3,19.3-8.6,38.7-6.2c0,0-11.9-7.4-20.3-5
			c-8.4,2.4-21.8,8.3-34.4,5.3C441.5,401.7,431.9,392.8,424.3,392.7z"
          />
          <path
            fill={colour0}
            d="M503.5,374c0,0-7.7,7.6-13.9,7.3l2.6,2.1C492.2,383.4,500.5,381.6,503.5,374z"
          />
          <path
            fill={colour0}
            d="M498,369.4c0,0-5.6,9.3-11.7,10.6l3.1,1.4C489.4,381.4,497,377.5,498,369.4z"
          />
          <path
            fill={colour0}
            d="M493,366.5c0,0-4.8,9.7-10.8,11.5l3.2,1.2C485.3,379.1,492.6,374.7,493,366.5z"
          />
          <path
            fill={colour0}
            d="M486.3,363.9c0,0-4,10.1-9.9,12.4l3.3,0.9C479.8,377.2,486.7,372.1,486.3,363.9z"
          />
          <path
            fill={colour0}
            d="M478.7,361.8c0,0-0.5,8.8-5.1,10.6l3.2,0.9C476.8,373.3,481.5,369.1,478.7,361.8z"
          />
        </g>
      </g>
    </>
  );
};

export default Eyes_12;
